import React, { useEffect, useState } from "react";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@mui/styles";
import { getIcon, getInsights } from "./Services/apiRoutes";
import "./App.css";
import Nlp from "./Pages/Nlp";
// import CoinVelocity from "./Pages/CoinVelocity";
import CoinVelocityTable from "./components/CoinVelocityTable"
import StoryVelocity from "./Pages/StoryVelocity";
import Events from "./components/Events";
import Research from "./components/Research";
import WganPricePrediction from "./Pages/WganPricePrediction";
import { ViewportProvider } from "./viewportListener";
import ChatBot from "./components/ChatBot";


export default function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#3f51b5",
      },
      secondary: {
        main: "#f50057",
      },
    },
    typography: {
      fontFamily: "Roboto, Arial",
    },
  });


  const newHash = window.location.hash;


  let view = <Nlp />
  // let view = <Events />
  // let view = <Research />
  // let view = <CoinVelocityTable />
  // let view = <StoryVelocity />
  // let view = <WganPricePrediction model={"wgan"}/>
  // let view = <WganPricePrediction model={"gan"}/>

  if (newHash === "#coin-velocity") {
    view = <CoinVelocityTable />;
  }
  if (newHash === "#story-velocity") {
    view = <StoryVelocity />;
  }
  if (newHash === "#events") {
    view = <Events />;
  }
  if (newHash === "#research") {
    view = <Research />;
  }
  if (newHash === "#wgan-price-prediction") {
    view = <WganPricePrediction model={"wgan"} />;
  }
  if (newHash === "#gan-price-prediction") {
    view = <WganPricePrediction model={"gan"} />;
  }

  return (
    <ViewportProvider>
      <ThemeProvider theme={theme}>
        <div
          style={{
            marginTop: "30px",
            marginBottom: "30px",
          }}
        >
          {view}
          {/* <ChatBot /> */}
        </div>
      </ThemeProvider>
    </ViewportProvider>
  );
}
